import DataList from "./DataList";

import "./DataList.scss";

export * from "./DataList.types";

export { DataList };
